import { IDispatcherService, IDispatcher } from '../';
import { Application } from '../../models';
import { IApplicationActionsService } from './application.actionCreator';

export interface IApplicationStoreService {
    connect: (application: Application) => angular.IPromise<void>;
    disconnect: () => angular.IPromise<void>;
}

export interface IApplicationActionsDispatcherService extends IDispatcherService<IApplicationStoreService> { }

export class ApplicationActionsDispatcherService implements IApplicationActionsDispatcherService {
    static serviceId = 'applicationActionsDispatcherService';

    static $inject = ['applicationActionsService'];
    
    constructor(private _actionService: IApplicationActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IApplicationStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                connect: (app: Application) => dispatch(actionService.connect(app)),
                disconnect: () => dispatch(actionService.disconnect())
            }
        };
    }
}